import theme from '../../themes/green';

const styles = {
  wrapper: {
    background: theme.pallete.background,
    height: '100%',
  },
  wrapperOpen: {
    transform: 'translate(0, -30px)',
  },
  contents: {},
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/AddScenePanel/styles.js